import {FC} from 'react'
import {PopoverText} from '../../../../../components'
import {IFetchLogResponse} from '../../../../../services/types'
import dateformat from 'src/utils/dateformat'

interface RowDataProps {
  items: IFetchLogResponse['data']['data']
  rowNumber: number
}

export const RowData: FC<RowDataProps> = (props) => {
  const {items, rowNumber} = props

  return (
    <>
      {items.map((item, index) => (
        <tr key={item.id}>
          <td>{index + 1 + rowNumber}</td>
          <td>
            <PopoverText
              content={item?.agent ? item?.agent : '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>{item?.ip_address}</td>
          <td>{item?.method}</td>
          <td>
            <PopoverText
              content={item?.body ? item?.body : '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>{item?.status}</td>
          <td>
            <PopoverText
              content={item?.endpoint ? item?.endpoint : '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>
            <PopoverText
              content={item?.header ? item?.header : '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>
            <PopoverText
              content={item?.response ? item?.response : '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>{dateformat(item?.created_at, {showtime: true})}</td>
          <td>{dateformat(item?.updated_at, {showtime: true})}</td>
        </tr>
      ))}
    </>
  )
}
